module.exports = __webpack_public_path__ + "6923e7fb7ee24f156b9b7216519405bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/address-info/icon-location.png
// module id = ./src/components/address-info/icon-location.png
// module chunks = index